/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useGuests} from '../../../../hooks/useGuests'
import {RatioCheckinOutData} from '../../../../models/reports.model'
import {
  getRatioCheckInOutCSVService,
  getRatioCheckInOutExcelService,
  getRatioCheckInOutPDFService,
} from '../../../../services/ratio.service'

interface Props {
  datos: RatioCheckinOutData[]
  loading: boolean
  getRatios: (data: any) => void
  siteSelected: string | null
  formValue: any
  total: number
}

const TableReportRatioCheckinout: FC<Props> = ({
  datos,
  loading,
  getRatios,
  siteSelected,
  formValue,
  total,
}) => {
  const {setPagination, pagination, updateTable, setUpdateTable, clearTable, setClearTable} =
    useKTable()
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [guests, setGuests] = useState<SelectOption[]>([])
  const [documentTypes, setDocumentTypes] = useState<SelectOption[]>([])
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const {getMasterTable, getDocumentTypesByCode} = useCentralServices()
  const {getGuests} = useGuests()

  ///
  ///
  useEffect(() => {
    getBedTypesFn()
    getCompanyTypesFn()
    getStatusTypesFn()
    getDocumentTypesFn()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBedTypesFn = async () => {
    const data = await getMasterTable('TipoCama', true)
    setBedTypes(data)
  }

  const getCompanyTypesFn = async () => {
    const data = await getMasterTable('TipoEmpresa', true)
    setCompanyType(data)
  }

  const getStatusTypesFn = async () => {
    const data = await getMasterTable('EstadoReservaCamaHuesped', true)

    const filterData = data.filter((item) => item.codigo !== '7' && item.codigo !== '5')
    var customOrder = ['PENDIENTE', 'GENERADA', 'ASIGNADA', 'CHECK IN', 'CHECK OUT']
    filterData.sort(function (a, b) {
      return customOrder.indexOf(a.nombreCorto) - customOrder.indexOf(b.nombreCorto)
    })
    setStatusType(filterData)
  }

  const getGuestsFn = async (siteId: string | null) => {
    const data = await getGuests({pageNumber: 1, size: 2000, SiteId: siteId})
    setGuests(data)
  }

  const getDocumentTypesFn = async () => {
    const data = await getDocumentTypesByCode()
    setDocumentTypes(data)
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getRatios({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getRatios({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  // useEffect(() => {
  //   getGuestsFn(siteSelected)
  // }, [siteSelected])

  useEffect(() => {
    getRatios({pageNumber: pagination.currentPage, size: pagination.perPage})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setPagination({...pagination, totalResults: total})
  }, [total])

  const columns: Column<RatioCheckinOutData>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de cama'
            name='TipoCamaId'
            selecteable
            data={bedTypes}
          />
        ),
        accessor: 'CamaTipo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo Doc.'
            name='TipoDoc'
            data={documentTypes}
            selecteable
          />
        ),
        accessor: 'TipoDocDescripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc.' name='NroDoc' searcheable />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedNombres'
            searcheable
            // data={guests}
          />
        ),
        accessor: 'HuespedDescripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tip. Empresa'
            name='TipoEmpresaId'
            selecteable
            data={companyType}
          />
        ),
        accessor: 'TipoEmpresa',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Reserva'
            name='EstadoReservaCamaId'
            data={statusType}
            selecteable
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio Programada'
            name='FechaIni'
            dateable
          />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Salida Programada'
            name='FechaFin'
            dateable
          />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check in' name='FechaCheckIn' dateable />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check out' name='FechaCheckOut' dateable />
        ),
        accessor: 'FechaCheckOut',
      },
    ],
    [bedTypes, companyType, statusType, guests],
  )

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioCheckInOutExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioCheckInOutCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioCheckInOutPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>

        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={datos} columns={columns} />
      </KTCard>
    </>
  )
}

const TableReportRatioCheckinoutWrapper: FC<Props> = ({
  datos,
  loading,
  getRatios,
  siteSelected,
  formValue,
  total,
}) => {
  return (
    <KTableProvider>
      <TableReportRatioCheckinout
        datos={datos}
        loading={loading}
        getRatios={getRatios}
        siteSelected={siteSelected}
        formValue={formValue}
        total={total}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportRatioCheckinoutWrapper}
